// extracted by mini-css-extract-plugin
module.exports = {"star":"GatheringsTable_star__2ovyv","ratingContainer":"GatheringsTable_ratingContainer__2RalT","starsContainer":"GatheringsTable_starsContainer__YZWZD"};